export default __webpack_public_path__ + "static/media/feature-team_tab_3.73e9452b4d13cd93c1cfdea3d9de1646.svg";